module.exports = __webpack_public_path__ + "static/AshleyBrown_lab-f985910f0ff6da409427a41a99303b81.png";